import styled from 'styled-components';

export const SegmentedControlWrapper = styled.div<{ $bgColor?: string | null }>`
  flex-shrink: 0;
  padding: 1rem;
`;

export const SegmentedTrack = styled.div<{ $trackBg?: string | null }>`
  display: flex;
  align-items: center;
  height: 2.5rem;
  background: ${({ $trackBg, theme }) => $trackBg || (theme as any).color.ui.grey[70]};
  border-radius: 1.25rem;
  padding: 0.1875rem;
`;

export const SegmentedItem = styled.button<{
  $active: boolean;
  $activeBg?: string | null;
  $activeTextColor?: string | null;
}>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.125rem;
  border-radius: 1.125rem;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.25rem;
  transition: background 300ms ease, color 300ms ease, box-shadow 300ms ease;
  padding: 0 0.5rem;
  min-width: 0;

  background: ${({ $active, $activeBg, theme }) =>
    $active ? $activeBg || (theme as any).color.ui.grey[10] : 'transparent'};
  color: ${({ $active, $activeTextColor, theme }) =>
    $active ? $activeTextColor || (theme as any).color.ui.grey[100] : '#fff'};
  box-shadow: ${({ $active }) =>
    $active ? '0 0.625rem 0.46875rem rgba(0,0,0,0.10), 0 0.25rem 0.1875rem rgba(0,0,0,0.05)' : 'none'};

  &:focus-visible {
    outline: 0.125rem solid #fff;
    outline-offset: 0.125rem;
  }
`;
